/* eslint-disable max-lines */

import {
    WISHLISTS_POPUP_ID,
} from '@scandiweb/amasty-multiple-wishlist/src/component/MultipleWishlist/MultipleWishlist.config';
import MultipleWishlistPopup
    from '@scandiweb/amasty-multiple-wishlist/src/component/MultipleWishlistPopup/MultipleWishlistPopup.container';

import ChevronIcon from 'Component/ChevronIcon';
import {Directions} from 'Component/ChevronIcon/ChevronIcon.config';
import ClickOutside from 'Component/ClickOutside';
import DeliveryIcon from 'Component/DeliveryIcon';
import DesktopDeliveryMenu from 'Component/DesktopDeliveryMenu';
import DesktopMenuIcon from 'Component/DesktopMenuIcon';
import {Page} from 'Component/Header/Header.config';
import {HeaderComponentProps} from 'Component/Header/Header.type';
import HeaderLogo from 'Component/HeaderLogo/HeaderLogo.container';
import Link from 'Component/Link';
import Menu from 'Component/Menu';
import {DEFAULT_STATE_NAME} from 'Component/NavigationAbstract/NavigationAbstract.config';
import OfflineNotice from 'Component/OfflineNotice';
import Popup from 'Component/Popup';
import SearchField from 'Component/SearchField';
import TextPlaceholder from 'Component/TextPlaceholder';
import {TextPlaceHolderLength} from 'Component/TextPlaceholder/TextPlaceholder.config';
import UserIcon from 'Component/UserIcon';
import WishlistIcon from 'Component/WishlistIcon';
import {
    CartOverlay,
    HeaderComponent as SourceHeaderComponent,
    MyAccountOverlay,
} from 'SourceComponent/Header/Header.component';
import {ReactElement} from 'Type/Common.type';
import {isSignedIn} from 'Util/Auth/IsSignedIn';
import {isCrawler, isSSR} from 'Util/Browser';
import {decodeString} from 'Util/Common';
import CSS from 'Util/CSS';
import media from 'Util/Media';
import {LOGO_MEDIA} from 'Util/Media/Media';
import {formatPrice} from 'Util/Price';

import './Header.override.style';

export {
    CartOverlay,
    MyAccountOverlay,
};

/** @namespace Steinkrueger/Component/Header/Component */
export class HeaderComponent extends SourceHeaderComponent {
    static defaultProps: Partial<HeaderComponentProps> = {
        logo_alt: 'ScandiPWA logo',
        logo_height: 25,
        logo_width: 200,
        showMyAccountLogin: true,
        header_logo_src: '',
        isLoading: true,
    };

    stateMap: Record<string, Record<string, boolean>> = {
        [DEFAULT_STATE_NAME]: {
            title: false,
            logo: true,
        },
        [Page.NO_MATCH]: {
            title: false,
            logo: true,
        },
        [Page.POPUP]: {
            title: false,
            close: true,
            logo: true,
        },
        [Page.PDP]: {
            back: true,
            title: false,
            logo: true,
        },
        [Page.CATEGORY]: {
            back: true,
            title: false,
            logo: true,
        },
        [Page.CUSTOMER_ACCOUNT]: {
            title: false,
            logo: true,
        },
        [Page.CUSTOMER_SUB_ACCOUNT]: {
            title: false,
            back: false,
            logo: true,
        },
        [Page.CUSTOMER_ACCOUNT_PAGE]: {
            title: false,
            logo: true,
        },
        [Page.CUSTOMER_WISHLIST]: {
            share: false,
            title: false,
            logo: true,
        },
        [Page.CUSTOMER_ORDER]: {
            title: false,
            back: false,
            logo: true,
        },
        [Page.MENU]: {
            back: false,
            search: true,
            logo: true,
        },
        [Page.MENU_SUBCATEGORY]: {
            back: false,
            title: false,
            search: true,
        },
        [Page.SEARCH]: {
            search: true,
            logo: true,
        },
        [Page.CART]: {
            title: false,
            logo: true,
        },
        [Page.CART_OVERLAY]: {
            title: false,
            logo: true,
        },
        [Page.CART_EDITING]: {
            ok: true,
            title: false,
            cancel: true,
        },
        [Page.FILTER]: {
            close: true,
            title: false,
        },
        [Page.CHECKOUT]: {
            back: false,
            title: false,
            account: true,
        },
        [Page.CHECKOUT_SUCCESS]: {
            title: false,
            account: true,
        },
        [Page.CHECKOUT_ACCOUNT]: {
            title: false,
            close: true,
        },
        [Page.CMS_PAGE]: {
            back: true,
            title: false,
            logo: true,
        },
        [Page.CONTACT_US]: {
            title: false,
            back: false,
            logo: true,
        },
        [Page.PRODUCT_COMPARE]: {
            title: false,
            back: true,
            logo: true,
        },
    };

    renderMap = {
        logo: this.renderLogo.bind(this),
        cancel: this.renderCancelButton.bind(this),
        back: this.renderBackButton.bind(this),
        close: this.renderCloseButton.bind(this),
        title: this.renderTitle.bind(this),
        search: this.renderSearchField.bind(this),
        renderDesktopIcons: this.renderDesktopIcons.bind(this),
        share: this.renderShareWishListButton.bind(this),
        ok: this.renderOkButton.bind(this),
    };

    renderLogo(isVisible = false): ReactElement {
        const { isLoading } = this.props;

        if (isLoading) {
            return (
                <TextPlaceholder
                  mix={ { block: 'LogoPlaceholder' } }
                  key="logoPlaceholder"
                  length={ TextPlaceHolderLength.MEDIUM }
                />
            );
        }

        return (
            <Link
              to="/"
              aria-label="Go to homepage by clicking on ScandiPWA logo"
              aria-hidden={ !isVisible }
              tabIndex={ isVisible ? 0 : -1 }
              block="Header"
              elem="LogoWrapper"
              mods={ { isVisible } }
              key="logo"
            >
                { this.renderLogoImage() }
            </Link>
        );
    }

    renderDesktopMenuButton(): ReactElement {
        const {
            isDesktopMenuOpened,
            onDesktopMenuButtonClick,
            device: {
                isMobile,
            },
        } = this.props;

        if (!onDesktopMenuButtonClick || isMobile) {
            return null;
        }

        const shouldAvailableDateRender = !isMobile && isSignedIn();

        const opened = !!isDesktopMenuOpened;

        return (
            <>
                <button
                  id="DesktopMenuButton"
                  block="DesktopMenu"
                  elem="Button"
                  mods={ {opened} }
                  key="DesktopMenuButton"
                  onClick={ onDesktopMenuButtonClick }
                >
                    <span>{ __('Catalog ') }</span>
                    <DesktopMenuIcon isOpened={ opened } />
                </button>
                { shouldAvailableDateRender && this.renderAvailableDateButton() }
            </>
        );
    }

    renderAvailableDateButton(): ReactElement {
        const {
            isCheckout,
            isAvailableDateMenuOpened,
            onAvailableDateMenuOutsideClick,
            onAvailableDateMenuClick,
        } = this.props;

        const opened = !!isAvailableDateMenuOpened;

        if (isCheckout) {
            return false;
        }

        return (
            <ClickOutside onClick={ onAvailableDateMenuOutsideClick }>
                <div block="HeaderAvailableDate" mods={ {opened} }>
                    <DesktopDeliveryMenu opened={ opened } onAvailableDateMenuClick={ onAvailableDateMenuClick } />
                </div>
            </ClickOutside>
        );
    }

    renderLogoImage(): ReactElement {
        const {
            header_logo_src,
            logo_alt,
            logo_height,
            logo_width,
            isSticky,
            device: {
                isMobile,
            },
        } = this.props;

        const logoSrc = header_logo_src ? media(header_logo_src, LOGO_MEDIA) : null;

        CSS.setVariable(this.logoRef, 'header-logo-height', `${logo_height}px`);
        CSS.setVariable(this.logoRef, 'header-logo-width', `${logo_width}px`);

        return (
            <HeaderLogo
              { ...{ isSticky } }
              src={ logoSrc }
              alt={ logo_alt }
              title={ logo_alt }
              isMobile={ isMobile }
            />
        );
    }

    renderBackButton(isVisible = false): ReactElement {
        const { onBackButtonClick } = this.props;

        return (
            <div block="Header" elem="Back" key="back" aria-hidden={ !isVisible }>
                <button
                  block="Header"
                  elem="Button"
                  mods={ { type: 'back', isVisible } }
                  onClick={ onBackButtonClick }
                  aria-label="Go back"
                  aria-hidden={ !isVisible }
                  tabIndex={ isVisible ? 0 : -1 }
                >
                    <ChevronIcon direction={ Directions.LEFT } />
                </button>
            </div>
        );
    }

    renderDesktopIcons(): ReactElement {
        return (
            <div
              block="Header"
              elem="IconsWrapper"
              key="desktop-icons"
            >
                { this.renderAccount() }
                { this.renderWishListLink() }
                { this.renderOrdersLink() }
                { this.renderMinicart() }
            </div>
        );
    }

    renderWishListLink(): ReactElement {
        const {
            device,
            isCheckout,
        } = this.props;

        const isLogged = isSignedIn();

        if (device.isMobile || !isLogged || isCheckout) {
            return null;
        }

        return (
            <Link
              to="wishlists"
              key="wishlist"
              block="Header"
              elem="Button"
              mods={ { type: 'wishlist' } }
              aria-label={ __('Wishlist Page') }
            >
                <WishlistIcon />
            </Link>
        );
    }

    renderShareWishListButton(): ReactElement {
        return null;
    }

    renderOrdersLink(): ReactElement {
        const {
            device,
            isCheckout,
        } = this.props;

        const isLogged = isSignedIn();

        if (device.isMobile || !isLogged || isCheckout) {
            return null;
        }

        return (
            <Link
              to="sales/order/history"
              key="orderHistory"
              block="Header"
              elem="Button"
              mods={ { type: 'orders' } }
              aria-label={ __('Order History Page') }
            >
                <DeliveryIcon />
            </Link>
        );
    }

    renderAccountButton(): ReactElement {
        const {
            onMyAccountButtonClick,
            device,
        } = this.props;

        const isLogged = isSignedIn();

        if (device.isMobile) {
            return null;
        }

        return (
            <button
              block="Header"
              elem="MyAccountWrapper"
              tabIndex={ 0 }
              onClick={ onMyAccountButtonClick }
              aria-label="Open my account"
              id="myAccount"
            >
                { !isLogged && this.renderNotLoggedIcon() }
                { isLogged && this.renderWelcomeMessage() }
            </button>
        );
    }

    renderNotLoggedIcon(): ReactElement {
        return (
            <>
                <UserIcon />
                <span block="Header" elem="LogIn">{ __('Log in') }</span>
            </>
        );
    }

    renderWelcomeMessage(): ReactElement {
        const { firstname } = this.props;

        if (!isSignedIn() || !firstname) {
            return null;
        }

        return (
            <>
                <UserIcon />
                <span
                  block="Header"
                  elem="Welcome"
                  mods={ {type: 'Welcome'} }
                >
                    <span>
                        { firstname }
                    </span>
                </span>
            </>

        );
    }

    renderMinicartItemsQty(): ReactElement {
        const {cartTotals: {total_quantity, prices}} = this.props;
        const {subtotal_excluding_tax} = {...prices};
        const {value} = {...subtotal_excluding_tax};
        // eslint-disable-next-line
        let priceFormatted = '';
        const formattedQty = new Intl.NumberFormat('de').format(total_quantity || 0);

        if (!total_quantity || !value) {
            return null;
        }

        if (value) {
            priceFormatted = formatPrice(Number(value));
        }

        return (
            <>
                <span
                  aria-label="Items in cart"
                  block="Header"
                  elem="MinicartItemCount"
                >
                    { formattedQty }
                </span>
                <span block="Header" elem="MinicartPrice">
                    { priceFormatted }
                </span>
            </>

        );
    }

    renderAccount(): ReactElement {
        const {
            onMyAccountOutsideClick,
            isCheckout,
            device: { isMobile },
        } = this.props;

        // on mobile hide button if not in checkout
        if (isMobile && !isCheckout) {
            return null;
        }

        if (isCheckout && isSignedIn()) {
            return null;
        }

        return (
            <div key="account" block="Header" elem="MyAccountContainer">
                <ClickOutside
                  onClick={ onMyAccountOutsideClick }
                >
                    <div
                      aria-label="My account"
                      block="Header"
                      elem="MyAccount"
                    >
                        { this.renderAccountButton() }
                        { this.renderAccountOverlay() }
                    </div>
                </ClickOutside>
            </div>
        );
    }

    renderSearchField(isVisible = false): ReactElement {
        const {
            searchCriteria,
            onSearchOutsideClick,
            onSearchBarFocus,
            onSearchBarChange,
            onClearSearchButtonClick,
            navigationState: { name },
            isCheckout,
            hideActiveOverlay,
            isPLP,
            device: {
                isMobile,
            },
        } = this.props;

        if (isCheckout) {
            return null;
        }

        if (!isSignedIn()) {
            return null;
        }

        const shouldAvailableDateRender = isPLP && !isMobile && isSignedIn();

        return (
            <SearchField
              key="search"
              searchCriteria={ searchCriteria }
              onSearchOutsideClick={ onSearchOutsideClick }
              onSearchBarFocus={ onSearchBarFocus }
              onSearchBarChange={ onSearchBarChange }
              onClearSearchButtonClick={ onClearSearchButtonClick }
              isVisible={ isVisible }
              isActive={ name === Page.SEARCH }
              shouldAvailableDateRender={ shouldAvailableDateRender }
              hideActiveOverlay={ hideActiveOverlay }
            />
        );
    }

    renderMenu(): ReactElement {
        const {
            isCheckout,
            device: { isMobile },
            isDesktopMenuOpened,
            onDesktopMenuButtonClick,
            onDesktopMenuOutsideClick,
            isPLP,
        } = this.props;

        if (isMobile || isCheckout || !onDesktopMenuButtonClick) {
            return isSignedIn() ? (isPLP && this.renderAvailableDateButton()) : false;
        }

        const visible = isDesktopMenuOpened;
        const availableDate = !isMobile && isSignedIn();

        return (
            <>
                <ClickOutside onClick={ onDesktopMenuOutsideClick }>
                    <div block="DesktopMenuButton" elem="Wrapper" mods={ {availableDate} }>
                        { this.renderDesktopMenuButton() }
                    </div>
                    <div block="DesktopMenu" elem="Wrapper" mods={ {visible} }>
                        <Menu key="menu" />
                    </div>
                </ClickOutside>
                { visible && (<div block="DesktopMenu" elem="Overlay" />) }
            </>
        );
    }

    renderTitle(isVisible = false): ReactElement {
        const { navigationState: { title } } = this.props;

        if (!isVisible) {
            return null;
        }

        return (
            <h1
              key="title"
              block="Header"
              elem="Title"
              mods={ { isVisible } }
            >
                { title ? (<span>{ decodeString(title.replace(/\+/g, ' ')) }</span>) : (<span>{ title }</span>) }
            </h1>
        );
    }

    renderWishlistPopup(): ReactElement {
        return (
            <Popup
              id={ `${WISHLISTS_POPUP_ID }add` }
              mix={ { block: 'ProductWishlist', elem: 'Popup' } }
            >
                <MultipleWishlistPopup />
            </Popup>
        );
    }

    render(): ReactElement {
        const { stateMap } = this;
        const {
            navigationState: { name, isHiddenOnMobile = false },
            isCheckout,
            device: { isMobile },
            isSticky,
        } = this.props;

        if (!isMobile) {
            // hide edit button on desktop
            stateMap[Page.CUSTOMER_WISHLIST].edit = false;
            stateMap[Page.CUSTOMER_WISHLIST].share = false;
            stateMap[Page.CART_OVERLAY].edit = false;
        }

        const loggedIn = isSignedIn();

        if (!loggedIn) {
            const notLoggedIn = true;

            return (
                <section
                  block="Header"
                  elem="Wrapper"
                  mods={ { isPrerendered: isSSR() || isCrawler(), name } }
                >
                    <header
                      block="Header"
                      mods={ {
                          name, isHiddenOnMobile, isCheckout, isSticky, notLoggedIn,
                      } }
                      mix={ { block: 'FixedElement', elem: 'Top' } }
                      ref={ this.logoRef }
                    >
                        <nav block="Header" elem="Nav">
                            { this.renderNavigationState() }
                        </nav>
                        { this.renderMenu() }
                    </header>
                    <OfflineNotice />
                </section>
            );
        }

        return (
            <>
                <section
                  block="Header"
                  elem="Wrapper"
                  mods={ { isPrerendered: isSSR() || isCrawler(), name, loggedIn } }
                >
                    <header
                      block="Header"
                      mods={ {
                          name, isHiddenOnMobile, isCheckout, isSticky, loggedIn,
                      } }
                      mix={ { block: 'FixedElement', elem: 'Top' } }
                      ref={ this.logoRef }
                    >
                        <nav block="Header" elem="Nav">
                            { this.renderNavigationState() }
                        </nav>
                        { this.renderMenu() }
                    </header>
                    <OfflineNotice />
                </section>
                { this.renderWishlistPopup() }
            </>
        );
    }
}

export default HeaderComponent;
